import Vue from 'vue';

import { get, assign, cloneDeep } from 'lodash';
import { removeArrayItemByID } from 'utils/array';

import * as api from 'api/api-settings';
import * as types from '../mutation-types';


const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  error: null,
  notFound: null,
  meta: {},
  data: {},
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  error: null,
  notFound: null,
};

const state = {};

const getters = {
  SettingsPresets: state => type => state[type],
};

const actions = {
  GetSettingsPresets({ commit }, params) {
    const type = params.type;
    const query = params.query || {};

    commit(types.FETCH_SETTINGS_PRESETS_START, { type });
    api.getSettingsPresets(
      type,
      query,
      (response) => {
        commit(types.RECEIVE_SETTINGS_PRESETS, { type, response });
      },
      (description, status, error) => {
        if (status === 404) {
          commit(types.FETCH_SETTINGS_PRESETS_NOT_FOUND, { type, error });
        } else {
          commit(types.FETCH_SETTINGS_PRESETS_ERROR, { type, error });
        }
      },
    );
  },
  AddPresetToPresetsList({ commit }, { type, response }) {
    return new Promise((resolve) => {
      const data = cloneDeep(response.data);
      commit(types.ADD_PRESET_TO_PRESETS_LIST, { type, data });
      resolve(true);
    });
  },
  RemovePresetFromPresetsList({ commit }, { type, id }) {
    return new Promise((resolve) => {
      commit(types.REMOVE_PRESET_FROM_PRESETS_LIST, { type, id });
      resolve(true);
    });
  },
  ClearSettingsPresets({ commit }, { type }) {
    commit(types.CLEAR_SETTINGS_PRESETS_STORE, { type });
  },
};

const mutations = {
  [types.FETCH_SETTINGS_PRESETS_START](state, { type }) {
    if (state[type]) Vue.set(state, type, assign(state[type], neutralState, { fetching: true }));
    else Vue.set(state, type, assign({}, initState, { fetching: true }));
  },
  [types.FETCH_SETTINGS_PRESETS_ERROR](state, { type, error }) {
    Vue.set(state, type, assign(state[type], neutralState, { error }));
  },
  [types.FETCH_SETTINGS_PRESETS_NOT_FOUND](state, { type }) {
    Vue.set(state, type, assign({}, neutralState, { notFound: true }));
  },
  [types.RECEIVE_SETTINGS_PRESETS](state, { type, response }) {
    Vue.set(state, type, assign(state[type], neutralState, { ready: true, data: response.data, meta: response.meta }));
  },

  [types.CLEAR_SETTINGS_PRESETS_STORE](state, { type }) {
    Vue.set(state, type, assign({}, initState));
  },

  [types.ADD_PRESET_TO_PRESETS_LIST](state, { type, data }) {
    const addedByMeList = get(state[type], 'data.added_by_me.list', []);
    Vue.set(state[type].data.added_by_me, 'list', [...addedByMeList, data]);
  },

  [types.REMOVE_PRESET_FROM_PRESETS_LIST](state, { type, id }) {
    const list = get(state[type], 'data.added_by_me.list', []);
    removeArrayItemByID(list, id);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/settings/entities/settings-presets.js